module.exports = __webpack_public_path__ + "img/underwear_commando.4b61510f.png";